
import { createReducer, on } from '@ngrx/store';
import { ActivityState } from '../../models/activity-state';
import { BookingMembersListState } from '../../models/bookingMember-state';
import { SchedulesState } from '../../models/schedules-state';
import { StaffState } from '../../models/staff-state';
import * as schedulesActions from './schedules.actions';

export const schedulesKey = 'schedules';
export const staffKey = 'staff';
export const activityKey = 'activity';
export const bookingMemberKey = 'bookingMember';

export const initialState: SchedulesState = {
    dateProgram: new Date(),
    schedules: [],
    editSchedule: null,
    isLoaded: false,
    isLoading: false,
    scheduleError: null,
    scheduleSuccess: false
};

export const staffInitialState: StaffState = {
    staff: [],
    isLoaded: false,
    isLoading: false,
    loadMessages: false
};

export const bookingMembersInitialState: BookingMembersListState = {
    bookingMemberList: {
        countMemberInWaitQueue: 0,
        detail: []
    },
    isLoaded: false,
    isLoading: false,
    loadMessages: false
};

export const activityInitialState: ActivityState = {
    activity: [],
    isLoaded: false,
    isLoading: false,
    loadMessages: false
};
export const schedulesReducer = createReducer(
    initialState,
    on(schedulesActions.schedulesList, (state) => ({
        ...state,
        isLoading: true,
        scheduleError: null,
        isLoaded: false
    })),
    on(schedulesActions.schedulesListSuccess, (state, response) => ({
        ...state,
        schedules: response.schedules,
        isLoading: false,
        scheduleError: null,
        isLoaded: true
    })),
    on(schedulesActions.setSchedule, (state, response) => ({
        ...state,
        editSchedule: response.schedule,
        isLoading: false,
        scheduleError: null,
        scheduleSuccess: false,
        isLoaded: true
    })),
    on(schedulesActions.updateSchedule, (state, response) => ({
        ...state,
        schedule: response.schedule,
        scheduleError: null,
        scheduleSuccess: true,
        isLoading: false,
        isLoaded: true
    })),
    on(schedulesActions.updateScheduleFailure, (state, { errorMssg }) => ({
        ...state,
        isLoading: false,
        isLoaded: false,
        scheduleError: errorMssg,
        scheduleSuccess: false
    })),
    on(schedulesActions.updateScheduleSuccess, (state, { success }) => ({
        ...state,
        isLoading: false,
        isLoaded: false,
        scheduleError: null,
        scheduleSuccess: success
    })),
    on(schedulesActions.updateDateSchedule, (state, response) => ({
        ...state,
        dateProgram: response.date,
        isLoading: false,
        isLoaded: true,
        scheduleError: null
    })),
);

export const staffReducer = createReducer(
    staffInitialState,
    on(schedulesActions.staffList, (state) => ({
        ...state,
        isLoading: true,
        isLoaded: false,
    })),
    on(schedulesActions.staffListSuccess, (state, response) => ({
        ...state,
        staff: response.staff,
        isLoading: false,
        loadMessages: false,
        isLoaded: true
    })),
);

export const activityReducer = createReducer(
    activityInitialState,
    on(schedulesActions.activityList, (state) => ({
        ...state,
        isLoading: true,
        isLoaded: false,
    })),
    on(schedulesActions.activityListSuccess, (state, response) => ({
        ...state,
        activity: response.activities,
        isLoading: false,
        loadMessages: false,
        isLoaded: true
    })),
);

export const bookingMembersListReducer = createReducer(
    bookingMembersInitialState,
    on(schedulesActions.bookingMembersList, (state) => ({
        ...state,
        isLoading: true,
        isLoaded: false,
    })),
    on(schedulesActions.bookingMembersListSuccess, (state, response) => ({
        ...state,
        bookingMemberList: response.bookingMembers,
        isLoading: false,
        loadMessages: false,
        isLoaded: true
    })),
);
